import { combineReducers, createReducer, on } from '@ngrx/store';
import { addAllAccounts, decrementCurrentWizardStep, incrementCurrentWizardStep, resetAccountResultsLoaded, resetCurrentWizardStep, resetSelectAllAccounts, resetSelectedAccounts, selectAccount, setAccountResultsLoaded, setImportType, setPortfolioImportType, toggleSelectAllAccounts, } from './actions';
import { CLIENT_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => {
    return state + 1;
}), on(decrementCurrentWizardStep, (state) => {
    return state - 1;
}), on(resetCurrentWizardStep, () => {
    return 0;
}));
export const selectedAccounts = createReducer([], on(selectAccount, (state, { selectedAccountNumber: newAccountId }) => {
    if (state.map((account) => account.id).includes(newAccountId)) {
        return state.filter((account) => account.id !== newAccountId);
    }
    return [...state, { id: newAccountId, importAsSingleHolding: false }];
}), on(resetSelectedAccounts, () => {
    return [];
}), on(setImportType, (state, { id, importAsSingleHolding }) => {
    if (state.map((account) => account.id).includes(id)) {
        return state.map((account) => {
            if (account.id === id) {
                return { ...account, importAsSingleHolding };
            }
            return account;
        });
    }
    return [...state, { id, importAsSingleHolding }];
}), on(addAllAccounts, (state, { accounts }) => {
    return accounts.map((account) => {
        return { id: account.account_number, importAsSingleHolding: false };
    });
}));
export const selectAllAccounts = createReducer(false, on(toggleSelectAllAccounts, (state) => {
    return !state;
}), on(resetSelectAllAccounts, () => {
    return false;
}), on(resetSelectedAccounts, () => {
    return false;
}));
export const portfolioImportType = createReducer(CLIENT_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => {
    return newPortfolioImportType;
}));
export const accountResultsLoaded = createReducer(false, on(setAccountResultsLoaded, (state, action) => {
    return action.loaded;
}), on(resetAccountResultsLoaded, () => {
    return false;
}));
export const avisoImportHoldings = combineReducers({
    currentWizardStepIndex,
    selectedAccounts,
    selectAllAccounts,
    portfolioImportType,
    accountResultsLoaded,
});
